import { Controller } from "stimulus"

export default class extends Controller {
  toggleCustomMemo(e) {
    if (e.target.value === 'true') {
      $('.memo-input').removeClass('d-none')
    } else {
      $('.memo-input').addClass('d-none')
    }
  }
}